<p-chart #chart type="line" [data]="chartData" [options]="chartOptions" class="dynamic-data-chart"></p-chart>
<cc-exchange-buttons [exchangeCodes]="availableExchanges" [selectedExchangeCode]="selectedExchangeCode"
                     (selectedExchangeChange)="selectExchange($event)"> </cc-exchange-buttons>
